import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import closeIcon from "../../../assets/imgs/stats-promo-close-icon.png";
import { actions } from "../../../Redux/store";
import { useAdvancedStatsPromoStore } from "../../../zustandStore/advancedStatsPromoStore";
import { hapticsImpactLight } from "../../../lib/utils";

export default function AdvancedStatsPromo() {
	const { setHasSeenPromo } = useAdvancedStatsPromoStore();
	const [isClosing, setIsClosing] = useState(false);

	const handleClose = () => {
		setIsClosing(true);
		// Delay the actual close to allow exit animation to complete
		setTimeout(() => {
			hapticsImpactLight();
			setHasSeenPromo(true);
			actions.modal.closeAdvancedStatsPromoPopup(null);
		}, 200);
	};

	// Subtle animation variants for the promo container
	const promoVariants = {
		hidden: {
			opacity: 0,
			y: -8,
		},
		visible: {
			opacity: 1,
			y: 0,
			transition: {
				duration: 0.3,
				ease: "easeOut",
			},
		},
		exit: {
			opacity: 0,
			scale: 0.95,
			y: -12,
			transition: {
				duration: 0.2,
				ease: "easeIn",
			},
		},
	};

	// Simple fade-in for the NEW badge
	const badgeVariants = {
		hidden: { opacity: 0 },
		visible: {
			opacity: 1,
			transition: {
				delay: 0.1,
				duration: 0.3,
				ease: "easeOut",
			},
		},
	};

	// Subtle close button animation
	const closeButtonVariants = {
		hidden: { opacity: 0 },
		visible: {
			opacity: 1,
			transition: {
				delay: 0.2,
				duration: 0.3,
				ease: "easeOut",
			},
		},
		hover: {
			scale: 1.05,
			transition: { duration: 0.15 },
		},
		tap: {
			scale: 0.98,
		},
	};

	return (
		<AnimatePresence mode="wait">
			{!isClosing && (
				<motion.div
					variants={promoVariants}
					initial="hidden"
					animate="visible"
					exit="exit"
					className="relative h-[43px] w-fit rounded-[9.11px] bg-[#FFFFFF21] backdrop-blur-[4px] text-white font-medium text-[9.25px] flex items-center justify-center px-2"
				>
			<div className="flex items-center justify-center gap-1">
				<motion.div
					variants={badgeVariants}
					initial="hidden"
					animate="visible"
					className="w-[31.64px] h-[12.31px] rounded-[3.33px] text-white text-[7.82px] flex items-center justify-center bg-[linear-gradient(100.34deg,rgba(0,153,255,0.75)_1.07%,rgba(0,221,255,0.75)_99.05%)]"
				>
					NEW
				</motion.div>
				<motion.p
					initial={{ opacity: 0 }}
					animate={{ 
						opacity: 1,
						transition: { delay: 0.15, duration: 0.3, ease: "easeOut" }
					}}
				>
					See the metrics pros use – Check out advanced stats
				</motion.p>
			</div>

			{/* Triangular indicator pointing down to the button */}
			<motion.div
				initial={{ opacity: 0 }}
				animate={{ 
					opacity: 1,
					transition: { delay: 0.25, duration: 0.3, ease: "easeOut" }
				}}
				className="absolute top-full right-6 transform -translate-x-1/2"
			>
				<div className="w-0 h-0 border-l-[3.5px] border-r-[3.5px] border-t-[9px] border-l-transparent border-r-transparent border-t-[#FFFFFF1A]"></div>
			</motion.div>

			{/* Close icon with dark background positioned in top right corner */}
			<motion.div
				variants={closeButtonVariants}
				initial="hidden"
				animate="visible"
				whileHover="hover"
				whileTap="tap"
				className="absolute -top-[6px] -right-1 z-10 cursor-pointer"
				onClick={handleClose}
			>
				<img src={closeIcon} alt="Close" className="w-[15.35px] h-[15.35px]" />
			</motion.div>
		</motion.div>
			)}
		</AnimatePresence>
	);
}
